import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet, axiosDelete } from "./axiosFunctions";



//#region Api URL's --> 
const getTeeReportDataUrl               = '/api/admin/reports/getTeeReport';
const getGstReportDataUrl               = '/api/admin/reports/getGstReport';
const getCancellationGstReportDataUrl   = '/api/admin/reports/getCancellationGstReport';
const getSubscriptionReportDataUrl      = '/api/admin/reports/getSubscriptionReport';
const getCancellationReportDataUrl      = "/api/admin/reports/getCancellationReport";
const getRevenueReportDataUrl           = "/api/admin/reports/getRevenueReport";
const getVendorBookingReportDataUrl     = "/api/admin/reports/getVendorBookingReport";
const getCashCardReportDataUrl          = "/api/admin/reports/getCashCardReport";
const getCashCardBalanceDataUrl         = "/api/admin/reports/getCashCardBalance";
const getUserGuestAllDataUrl            = "/api/admin/reports/getUserGuestAllReport";
const getManyCashCardBalanceUrl         = "/api/admin/reports/getManyCashCardBalance";
//#endregion



export const getGstReportData = async(fromDate, toDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(getGstReportDataUrl, { fromDate, toDate }, { headers: { auth_token: `bearer ${token}` } });
    return response;
}


export const getCancelGstReportData = async(fromDate, toDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(getCancellationGstReportDataUrl, { fromDate, toDate }, { headers: { auth_token: `bearer ${token}` } });
    return response;
}


export const getSubscriptionReportData = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(getSubscriptionReportDataUrl, {}, { headers: { auth_token: `bearer ${token}` } });
    return response;
}


export const getVendorBookingReportData = async (fromDate, toDate, vendorID) => {
  const token = getAuthState("token");
  if (!token)
    setTimeout(() => {
      return;
    }, 2000);

  const response = await axiosPost(
    getVendorBookingReportDataUrl,
    { fromDate, toDate, vendorID },
    { headers: { auth_token: `bearer ${token}` } }
  );
  return response;
};


export const getRevenueReportData = async (fromDate, toDate) => {
  const token = getAuthState("token");
  if (!token)
    setTimeout(() => {
      return;
    }, 2000);

  const response = await axiosPost(
    getRevenueReportDataUrl,
    { fromDate, toDate },
    { headers: { auth_token: `bearer ${token}` } }
  );
  return response;
};
